/**
 * Paleta do novo layout do ABE Web.
 *
 * Os valores foram amostrados diretamente dos PNGs de referência
 * (pesquisa_check3.png, grid_icons_check.png, home-*.png), por isso são
 * exatos e não aproximações.
 *
 * Os nomes marcados com [legado] existem em
 * `abe-web-react/src/helpers/constants/colors.constants.js`. Foram mantidos
 * com o MESMO nome para que a migração do projeto real seja uma simples
 * troca de valor, sem refatorar imports.
 */

// ###### Núcleo: preto, branco, azul marinho e cinza ######
export const navy = '#0d2b52'; // primária: chips de título, botões preenchidos, menu ativo
export const navyDark = '#081d39'; // hover de botão preenchido
export const navyLight = '#14529d'; // links / realces
export const black = '#1f2430'; // texto padrão (não é preto puro nos prints)
export const blackTwo = '#000000';
export const white = '#ffffff';

export const pageBackground = '#e9edf2'; // fundo da área de conteúdo
export const paleGrey = '#f4f6f9'; // [legado] áreas internas (mural, linha zebrada)
export const badgeBlue = '#dfeaf9'; // fundo do número nos cards "Minhas informações"
export const borderGrey = '#d9dee5'; // bordas de input e divisores de tabela
export const warmGrey = '#6b7280'; // [legado] texto secundário / label
export const greyish = '#9aa3af'; // [legado] placeholder
export const disabledBg = '#b9bdc3'; // fundo de botão sem permissão (desabilitado)
export const disabledText = '#6b7280'; // texto de botão desabilitado

// ###### Estados / semântica ######
export const midGreen = '#2fa84f'; // [legado] status "Ativo", prazo futuro
export const tangerine = '#f2a33c'; // [legado] prazo do dia
export const tomato = '#d64545'; // [legado] prazo vencido
export const purple = '#8a2a7d'; // processo não trabalhado (mesmo valor do projeto real)
export const teal = '#0f9baa'; // chip do dropdown na home
export const tealSoft = '#dff3f5'; // fundo do chip do dropdown

// ###### Barra de ações em massa (bolinhas de cor da tela de processos) ######
export const acaoColors = ['#3fc6cf', '#4caf50', '#f2c14e', '#e39fd6'];

/**
 * Mapa de cor dos alertas da grid.
 * Espelha `abe-web-react/src/components/UI/AlertasProcesso/AlertasProcesso.jsx`,
 * onde M = vencido, L = no limite, V = no prazo.
 */
export const alertaFaseColor = { M: tomato, L: tangerine, V: midGreen };

export const compromissoColor = {
  EXPIRADO: tomato,
  EXPIRACAO_PROXIMA: tangerine,
  MARCADO: midGreen,
  DISABLED: '#e4e4e4',
};

// ###### Sombras e raios recorrentes nos prints ######
export const shadowCard = '0 1px 3px rgba(13, 43, 82, 0.10), 0 1px 2px rgba(13, 43, 82, 0.06)';
export const shadowFloat = '0 8px 24px rgba(13, 43, 82, 0.18)';
export const shadowChip = '2px 2px 2px 1px rgba(0, 0, 0, 0.20)';
export const radiusCard = 10;
export const radiusPill = 46;
export const radiusInput = 8;
